// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";

// Afidium
import { TravelDateBeginEndComponent } from 'libraries/component/sectors-air-details-list/components/traveller-date-begin-end/travel-date-begin-end.component';
import { DatePipeModule } from 'libraries/date/date.module';

@NgModule({
    imports: [
        CommonModule,
        DatePipeModule,
    ],
    exports: [TravelDateBeginEndComponent],
    declarations: [TravelDateBeginEndComponent],

})
export class TravelDateBeginEndModule {}

